import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {ExportadoresModel} from "./exportadores.model";
import {ExportadoresService} from './exportadores.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {PaisesService} from "../paises/paises.service";


@Component({
  selector: 'app-exportadores-form',
  templateUrl: './exportadores-form.component.html'
})
export class ExportadoresFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  exportador: ExportadoresModel = new ExportadoresModel();
  listPaises = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private exportadoresService: ExportadoresService,
    private paisesService: PaisesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]],
      id_pais: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_exportador'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.visualizarExportador');
      }else{
        this.title = id ? this.func.traduzir('front.editarExportador') : this.func.traduzir('front.cadastrarNovoExportador');
      }

      this.paisesService.get()
        .subscribe(
          json => {
            this.listPaises = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        return;
      }

      this.exportadoresService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarExportador')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarExportador') + ': ' + json.Payload[0].nome;
            }

            this.exportador = json.Payload[0];

            if (!this.exportador.id_pais || String(this.exportador.id_pais) === 'null' || String(this.exportador.id_pais) === 'undefined') {
              this.exportador.id_pais = null;
            }

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.exportador;

    if (!values.id_pais || String(values.id_pais) === 'null' || String(values.id_pais) === 'undefined' || String(values.id_pais) === '') {
      values.id_pais = null;
    }

    if (values.id) {
      result = this.exportadoresService.editar(values, values.id);
    } else {
      result = this.exportadoresService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'exportadores']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if(json.Message && json.Message.ErrorInput){
          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/exportadores/exportadores-form.component.ts